module.exports = __webpack_public_path__ + "static/images/swap.2dd96e919c41ac52f0e41e6da7883980.svg";